export default __webpack_public_path__ + "static/media/mass-logo.9229cd6c.png";